// Temporarily unavailable until real-game execution is verified.
// Keep implementations intact; never enable this from a URL or cached preference.
export const GAME_TOOLS_ENABLED = false
